export default "__VITE_ASSET__B3AW5Sim__"